module.exports = __webpack_public_path__ + "media/images/Fleche haut-adc455656ba023f7c9f812d229ea627e.svg";